import { MatchScoringInput, ScoredMatch } from "./matchScoring";

const STORAGE_KEY = "werule-intake-match-results";
const SESSION_KEY = "werule-intake-session-input";
const STEP_KEY = "werule-intake-return-step";

export type StoredIntakeMatches = {
  matches: ScoredMatch[];
  returnPath: string;
};

export function saveIntakeSession(session: MatchScoringInput): void {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function getIntakeSession(): MatchScoringInput | null {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? (JSON.parse(raw) as MatchScoringInput) : null;
  } catch {
    return null;
  }
}

export function markIntakeResultsStep(): void {
  sessionStorage.setItem(STEP_KEY, "results");
}

export function consumeIntakeResultsStep(): boolean {
  const value = sessionStorage.getItem(STEP_KEY);
  if (value === "results") {
    sessionStorage.removeItem(STEP_KEY);
    return true;
  }
  return false;
}

export function saveIntakeMatches(matches: ScoredMatch[], returnPath = "/intake"): void {
  const payload: StoredIntakeMatches = { matches, returnPath };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  markIntakeResultsStep();
}

export function getIntakeMatchForMentor(mentorId: string | number): ScoredMatch | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredIntakeMatches;
    return parsed.matches.find((m) => m.mentor.id === String(mentorId)) ?? null;
  } catch {
    return null;
  }
}

export function getIntakeReturnPath(): string | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return (JSON.parse(raw) as StoredIntakeMatches).returnPath;
  } catch {
    return null;
  }
}
